const Brand = () => {
  return (
    <div className="brand">
      <span> loopstudios</span>
    </div>
  );
};

export default Brand;
